import { defineLabels } from '@repo/locale-client';
import englishLabels from './translations/en.json' with { type: 'json' };
import polishLabels from './translations/pl.json' with { type: 'json' };
export const getLabels = defineLabels({ en: englishLabels, pl: polishLabels });
